import { arrayOf, object } from './type-checkers';
import { wrapCreator } from './util';

function record(): Function {
  return arrayOf(object);
}

export default wrapCreator(record, { type: 'record' }, true);
